// extracted by mini-css-extract-plugin
module.exports = {"swotSection":"swotStyles_swotSection__3_tVP","header":"swotStyles_header__31dI7","body":"swotStyles_body__1h5aq","download":"swotStyles_download__CWfk6"};